// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"oZ-z","subtitle":"pZ-z","wrapper":"qZ-z","leftArrow":"rZ-z","rightArrow":"sZ-z"};